import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { supabase } from "../supabase";

const Goals = () => {
  const [goals, setGoals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingGoal, setEditingGoal] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchGoals();
  }, []);

  const fetchGoals = async () => {
    try {
      const { data, error } = await supabase.from("goals").select("*");
      if (error) throw error;
      setGoals(data);
    } catch (error) {
      message.error("Error fetching goals");
    } finally {
      setLoading(false);
    }
  };

  const showModal = (goal = null) => {
    setEditingGoal(goal);
    setIsModalVisible(true);
    if (goal) {
      form.setFieldsValue(goal);
    } else {
      form.resetFields();
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleSubmit = async (values) => {
    try {
      if (editingGoal) {
        const { error } = await supabase
          .from("goals")
          .update(values)
          .eq("id", editingGoal.id);
        if (error) throw error;
        message.success("Goal updated successfully");
      } else {
        const { error } = await supabase.from("goals").insert([values]);
        if (error) throw error;
        message.success("Goal added successfully");
      }
      fetchGoals();
      handleCancel();
    } catch (error) {
      message.error("Error saving goal");
    }
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Button onClick={() => showModal(record)}>Edit</Button>
      ),
    },
  ];

  return (
    <div style={{ padding: "24px" }}>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => showModal()}
        style={{ marginBottom: 16 }}
      >
        Add Goal
      </Button>
      <Table columns={columns} dataSource={goals} loading={loading} rowKey="id" />
      <Modal
        title={editingGoal ? "Edit Goal" : "Add Goal"}
        visible={isModalVisible}
        onCancel={handleCancel}
        onOk={form.submit}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="title"
            label="Title"
            rules={[{ required: true, message: "Please input the title!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true, message: "Please input the description!" }]}
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Goals;
